/* eslint-disable i18next/no-literal-string */
import React, { useCallback, useState } from "react";
import styles from "./text-area.module.scss";
import classnames from "classnames";
import { observer } from "mobx-react-lite";
import type { TextAreaProps } from "@whatslly/types/UI-V2/BaseElements/TextAreaType";
import globalStyles from "../../globalStyles";

export const TextArea: React.FC<TextAreaProps> = observer(
  ({
    paddingInline,
    borderRadius,
    borderColor,
    marginTop,
    fontSize,
    outline,
    backgroundColor,
    fontWeight,
    marginBottom,
    textAreaSize,
    defaultValue,
    className,
    outlineWidth,
    color,
    placeholder,
    onChange,
    removeBorder,
    ...props
  }) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks, @typescript-eslint/no-explicit-any
    const [valueState, setValueState] = useState<string>(String(defaultValue ?? ""));

    const tuvisOnChange = useCallback(
      (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setValueState(e.target.value);
        if (onChange) {
          return onChange(e);
        }
      },
      [onChange]
    );

    return (
      <div
        className={classnames(
          styles.textAreaContainer,
          globalStyles[`pi-${paddingInline ?? "small"}`],
          globalStyles[`mb-${marginBottom ?? "none"}`],
          globalStyles[`fs-${fontSize ?? "default"}`],
          globalStyles[`mt-${marginTop ?? "none"}`]
        )}
      >
        <textarea
          placeholder={placeholder}
          onChange={tuvisOnChange}
          value={valueState}
          className={classnames(
            styles.textArea,
            globalStyles[`br-${borderRadius ?? "default"}`],
            globalStyles[`fs-${fontSize ?? "default"}`],
            globalStyles[`fw-${fontWeight ?? "default"}`],
            globalStyles[`text-area-${textAreaSize ?? "default"}`],
            globalStyles[`bg-color-${backgroundColor ?? "input"}`],
            globalStyles[`color-${color ?? "main-primary"}`],
            globalStyles[`bc-${borderColor ?? "neutral-secondary"}`],
            globalStyles[`outline-${outline ?? "neutral-primary"}`],
            globalStyles[`outline-width-${outlineWidth ?? "default"}`],
            globalStyles["v2ElementContainer"],
            { [styles.noBorder]: removeBorder },
            className
          )}
          {...props}
        />
      </div>
    );
  }
);
